import React from 'react';
import DocxEditor from '../DocxEditor';
import styles from './styles.module.scss';

interface PopupContentProps {
  file: Blob | File | string,
  onSave: (file: Blob) => void,
}

const PopupContent = ({file, onSave}: PopupContentProps) => {
  return (
    <div className={'w-100 h-100 d-flex flex-column align-items-center'}>
      <div className={'flex-grow-1 w-100'}>
        <DocxEditor
          file={file}
          onSave={onSave}
          className={styles.editor}
          height={'72vh'}
        />
      </div>
    </div>
  );
};

export default PopupContent;
